// Case Notes API
import { apiClient } from './client'

export interface CaseNote {
  id: string
  content: string
  author_name: string
  author_id?: string | null
  updated_by?: string | null
  updated_by_name?: string | null
  created_at: string
  updated_at: string
}

export interface CreateNoteRequest {
  content: string
  author_name: string
}

export interface UpdateNoteRequest {
  content: string
}

export const notesApi = {
  list: (caseId: string) => apiClient.get<CaseNote[]>(`/cases/${caseId}/notes/list`),

  create: (caseId: string, request: CreateNoteRequest) =>
    apiClient.post<CaseNote>(`/cases/${caseId}/notes/list`, request),

  update: (caseId: string, noteId: string, request: UpdateNoteRequest) =>
    apiClient.put<CaseNote>(`/cases/${caseId}/notes/list/${noteId}`, request),

  delete: (caseId: string, noteId: string) =>
    apiClient.delete<void>(`/cases/${caseId}/notes/list/${noteId}`),
}
